var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"text-center mt-5 font-2xl text-muted"},[_c('i',{staticClass:"fal fa-spinner fa-spin"}),_vm._v(" Submission Table Data Loading...\n")]):_c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{attrs:{"title":"Samples","active":""}},[_c('h3',[_vm._v("Samples")]),_c('sample-server-table',{attrs:{"analytes":_vm.analyte_collection,"sample_types":_vm.sample_type_collection,"show_columns":_vm.sample_columns,"show_add_btn":""}})],1),_c('b-tab',{attrs:{"title":"Test Packages"}},[_c('h3',[_vm._v("Test Packages")]),_c('test-package-server-table',{attrs:{"analytes":_vm.analyte_collection,"sample_types":_vm.sample_type_collection,"show_columns":[
          'name',
          'sample_type.name',
          'test_package_group.name',
          'description',
          'cost',
          'cost_add_on'
        ]}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }